import ajax from '@/assets/js/interceptor';
// import util from '@/assets/js/util';
export default {
  namespaced: true,
  state: {
    totalCount: 0,
    dataSource: [],
    maxSortNum: 0
  },
  mutations: {
    SAVE_STATE (state, payload = {}) {
      // 由于不想全部把state给改了，所以我想把每一个数据都单独塞一下
      const keyList = Object.keys(payload);
      keyList.forEach(key => {
        state[key] = payload[key];
      });
    }
  },
  actions: {
    getUserPermission ({ commit, dispatch, state }, payload) {
      // ajax.get('www.aldf.com');
    },
    getTableInfo ({ commit, dispatch, state }, payload) {
      console.log('payload', payload);
      ajax.post('/v1/appBase/list', payload.filter).then(res => {
        const { data } = res;
        console.log('data', data);
        if (data.code == 200) {
          const list = data.data.records;
          commit('SAVE_STATE', {
            dataSource: list, totalCount: data.data.total
          });
        }
      });
    },
    getMaxSortNum ({ commit, dispatch, state }, payload) {
      console.log('payload', payload);
      ajax.get('/v1/appBase/nextSortNum/').then(res => {
        const { data } = res;
        console.log('data', data);
        if (data.code == 200) {
          const num = data.data;
          commit('SAVE_STATE', {
            maxSortNum: num
          });
        }
      });
    },
    getTreeList ({ commit, dispatch, state }, payload) {
      return new Promise(resolve => {
        // ajax.get(departmentUrl).then(res => {
        //   console.log('res', res);
        // });
        // const jsonData = require('../../assets/js/test.json');
        // const dataMap = jsonData.map(item => {
        //   const { childDepartmentId, childDepartmentName, departmentId, ...rest } = item;
        //   return {
        //     id: childDepartmentId,
        //     title: childDepartmentName,
        //     pid: departmentId,
        //     toggleOpen: false,
        //     active: false,
        //     level: 0,
        //     ...rest
        //   };
        // });
        // const treeData = util.getMenuTree(dataMap);

        // commit('SAVE_STATE', { treeData });
        // resolve({ originData: dataMap, treeData });
      });
    },
    deleteApp ({ commit, dispatch, state }, { row, func }) {
      ajax.delete(`/v1/appBase/delete/${row.id}`).then(res => {
        const { data, code } = res.data;
        if (code == 200) {
          func('success', data);
        } else {
          func('error', data);
        }
      });
    }
  }
};
